import React from 'react'
import { Link } from 'react-router-dom'
import { GiGrandPiano } from "react-icons/gi";

function Recitals() {
  return (
    <>
      <div className='recitals-container container width'>
        <div style={{ textAlign: 'center' }}>
          <h2>Recitals</h2>
          <p>Join us for our upcoming recitals and performances.</p>
        </div>
        <div className='upcoming-container'>
          <div>
            <h3>Upcoming Recitals</h3>
            <ul>
              <li><GiGrandPiano />Next Recital - <b>Saturday, Mar. 7, 2026</b> at Centerville Library at 11:30am. <a href="https://share.google/mvTXM2gsqWP4X0ADu" target='_blank' rel='noopener noreferrer'>Click for directions</a></li>
            </ul>
            <p><b>Contact me for more details!</b></p>
          </div>
          <Link to="/contact"><button className='btn'>Contact</button></Link>
        </div>
      </div>
    </>
  )
}

export default Recitals